/**
 * Reads a boolean flag ("required" / "enabled") off a named share type in a
 * channel's `share_types` list.
 *
 * The channel show API intentionally omits deprecated share types (e.g.
 * "twitter" — see movebooth-rails #964), so a lookup can legitimately match
 * nothing. When that happens this resolves to `false` rather than throwing —
 * an unguarded `.find(...).required` on a now-absent entry is exactly what
 * crashed the channel editor in the 2026-05-12 production outage.
 *
 * @param {object} channel - channel object that may carry a `share_types` array
 * @param {string} name - share type name, e.g. "email" | "phone" | "twitter"
 * @param {"required"|"enabled"} key - which boolean flag to read
 * @returns {boolean} the flag value, or false when the share type is absent
 */
export const shareTypeFlag = (channel, name, key) =>
  channel?.share_types?.find((cst) => cst.name === name)?.[key] ?? false;
